<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="pa-0 ma-0">
    <v-dialog v-model="dialog" fullscreen persistent scrollable>
      <v-form v-model="valid" lazy-validation ref="form" id="new-form">
        <v-card>
          <v-card-title>
            <span class="headline">{{ dialogTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row dense>
                <v-col cols="6" sm="6" md="3">
                  <v-select
                    dense
                    :items="providers"
                    v-model="toBeEdit.providerid"
                    required
                    label="Provider"
                  ></v-select>
                </v-col>

                <v-col cols="6" sm="6" md="3">
                  <v-text-field
                    dense
                    v-model="toBeEdit.total"
                    required
                    :rules="priceRules"
                    label="Total amount (USD)"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="3">
                  <v-file-input
                    dense
                    v-model="toBeEdit.invoice"
                    accept="image/*"
                    label="Invoice File"
                  ></v-file-input>
                </v-col>

                <v-col cols="6" sm="6" md="3">
                  <v-switch
                    dense
                    v-model="toBeEdit.paid"
                    label="Paid in advance ?"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-sheet
                    class="flex-fill pb-4"
                    color="#f9f9f9"
                    outline
                    elevation="1"
                  >
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>Category</th>
                            <th>Part</th>
                            <th>Quantity</th>
                            <th>Unit Price</th>
                          </tr>
                        </thead>
                        <tbody v-if="gotcats">
                          <tr v-for="index in rows" :key="index">
                            <td class="align-center">
                              <v-autocomplete
                                dense
                                :items="cats"
                                v-model="selectedparts[index - 1].id"
                                @change="
                                  getParts(
                                    selectedparts[index - 1].id,
                                    index - 1
                                  )
                                "
                              >
                              </v-autocomplete>
                            </td>
                            <td>
                              <v-autocomplete
                                dense
                                :items="selectedparts[index - 1].parts"
                                v-model="selectedparts[index - 1].selected"
                              ></v-autocomplete>
                            </td>
                            <td>
                              <v-text-field
                                dense
                                v-model="selectedparts[index - 1].quan"
                                type="number"
                              />
                            </td>
                            <td>
                              <v-text-field
                                dense
                                v-model="selectedparts[index - 1].unitprice"
                                type="number"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-simple-table>
                      <template>
                        <tfoot>
                          <tr>
                            <td>
                              <v-btn
                                color="blue"
                                @click="addMore()"
                                class="white--text"
                              >
                                <v-icon dark class="me-2">mdi-plus</v-icon>
                                Add more rows
                              </v-btn>
                            </td>
                          </tr>
                        </tfoot>
                      </template>
                    </v-simple-table>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="dialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              dark
              form="new-form"
              @click="validate"
              :disabled="!valid"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">
          <v-spacer></v-spacer>
          <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-spacer></v-spacer>
            <v-btn @click="newClicked()" dark color="blue darken-4"
              ><v-icon class="mr-2">mdi-plus</v-icon> New Purchase Order</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :footer-props="{
                'items-per-page-options': [25, 50, 100, 150, -1]
              }"
              :items-per-page="50"
              :search="title"
              :loading="isloading"
              :loading-text="loadingtext"
              :headers="headers"
              :items="items"
              :pageCount="numberOfPages"
              :server-items-length="totalItems"
              :options.sync="options"
              ref="tbl"
            >
              <template slot="items" slot-scope="{ item }">
                <td>{{ item.id }}</td>
                <td>{{ item.providerid }}</td>
                <td>{{ item.total }}</td>
                <td><v-img :src="item.invoice"></v-img></td>
                <td>{{ item.paid }}</td>
                <td>{{ item.addby }}</td>
                <td>{{ item.adddate }}</td>
              </template>

              <template v-slot:item.total="{ item }">
                <v-chip
                  ><strong>${{ item.total }}</strong></v-chip
                >
              </template>

              <template v-slot:item.paid="{ item }">
                <v-chip :color="getColor(item.paid)" dark>
                  {{ item.paid }}</v-chip
                >
              </template>

              <template v-slot:item.invoice="{ item }">
                <v-img
                  class="datatableimg my-2"
                  max-width="100"
                  max-height="40"
                  :src="item.invoice"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="black"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </template>

              <template v-slot:item.action="{ item }">
                <div
                  class="d-flex align-center align-content-center justify-center"
                >
                  <v-btn
                    class="actionbtns mx-1"
                    primary
                    dark
                    small
                    color="orange"
                    center
                    @click="editClicked(item)"
                  >
                    <v-icon medium>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="actionbtns mx-1"
                    color="red"
                    small
                    warning
                    dark
                    @click="deleteItem(item)"
                  >
                    <v-icon medium>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
  </v-container>
</template>

<script>
import { __HTTP, FormHeader, UploadHeader, __HAS_PERM } from "@/utils/utils";

export default {
  name: "Purchases",
  computed: {
    grandtotal() {
      let index = this.shippingtypes.findIndex(
        o => o.value == this.shippingtype.value
      );
      var xxx = 0;
      if (this.invoicetype == "pc") {
        //console.log(this.shippingtypes);
        //console.log("Types",this.shippingtypes[index]);
        xxx =
          parseInt(this.total == "" ? 0 : this.total) -
          parseInt(this.discount == "" ? 0 : this.discount) +
          parseInt(this.shippingtypes[index].price);
      } else {
        var total = 0;
        this.selectedparts.forEach(el => {
          if (el.selected != null) {
            // console.log(el);
            total += parseInt(el.quan * el.unitprice);
          }
        });
        //this.total = total;
        xxx =
          total -
          parseInt(this.discount == "" ? 0 : this.discount) +
          parseInt(this.shippingtypes[index].price);
      }
      return xxx;
    }
  },
  components: {},
  watch: {
    options: {
      handler() {
        this.getList()
      }
    }
    },
  methods: {
    getColor(shown) {
      if (shown === "Yes") return "green";
      else return "red";
    },
    addMore() {
      this.selectedparts.push({
        id: null,
        parts: [],
        selected: null,
        quan: 1,
        unitprice: 0
      });
      this.rows++;
    },
    getParts: function(val, i) {
      __HTTP("?do=getparts", JSON.stringify({ id: val }), FormHeader, res => {
        this.selectedparts[i].parts = res;
        this.selectedparts[i].price = res[0].cost;
      });
    },
    getCats() {
      __HTTP("?do=getcats", "", FormHeader, res => {
        //console.log(res);
        this.cats = res;
        this.selectedparts = new Array();
        for (let index = 0; index < res.length; index++) {
          //const element = res[index];
          this.selectedparts.push({
            id: res[index].value,
            parts: [],
            selected: null,
            quan: 1,
            unitprice: 0
          });
          this.getParts(res[index].value, index);
        }
        //console.log(this.selectedparts);
        this.rows = res.length;
        this.cache = { rows: res.length, selectedparts: this.selectedparts };
        this.gotcats = true;
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.insertNewItem();
      }
    },
    newClicked() {
      this.dialogTitle = "New Purchase Order";
      this.rows = this.cache.rows;
      this.selectedparts = this.cache.selectedparts;
      this.toBeEdit = {
        providerid: "",
        total: "",
        invoice: "",
        paid: "",
        isnew: true,
        id: 0
      };
      this.dialog = true;
    },

    editClicked(item) {
      this.$router.push({
        path: "/editpurchase",
        query: { purchaseid: item.id }
      });
      //console.log(item);
      /* this.dialogTitle = "Edit Purchase Order";
      this.rows = item.items.length;
      this.selectedparts = item.items;
      this.toBeEdit = {
        providerid: item.providerid,
        total: item.total,
        invoice: item.invoice,
        paid: item.paid == "Yes" ? true : false,
        isnew: false,
        id: item.id
      };
      this.dialog = true;
       */

    },
    getProviders() {
      this.isloading = true;
      __HTTP(
        "?do=getproviders",
        JSON.stringify({ keyword: "" }),
        FormHeader,
        res => {
          this.isloading = false;
          this.providers = res;
        }
      );
    },
    getList() {
      this.isloading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = page - 1;
      this.items = [];
      __HTTP(
        "?do=list&type=purchases",
        JSON.stringify({ keyword: "",
        pageNumber: pageNumber,
          itemsPerPage: itemsPerPage, }),
        FormHeader,
        res => {
          console.log("Purchases", res);
          this.numberOfPages = res.numOfPages;
          this.totalItems = parseInt(res.items);
          this.isloading = false;
          this.items = res.data;
        }
      );
    },
    insertNewItem() {
      var fd = new FormData();
      fd.append("file", this.toBeEdit.invoice);
      var ss = new Array();
      this.selectedparts.forEach(e => {
        if (e.selected != null) {
          ss.push({ id: e.selected, quan: e.quan, unitprice: e.unitprice });
        }
      });
      const vv = JSON.stringify({
        id: this.toBeEdit.id,
        providerid: this.toBeEdit.providerid,
        total: this.toBeEdit.total,
        parts: ss,
        paid: this.toBeEdit.paid
      });
     // console.log("Send", vv);
      fd.append("data", vv);
      //console.log(vv);
      __HAS_PERM(
        this.toBeEdit.isnew ? 39 : 37,
        this.$store.state.loggedUser.id,
        () => {
          __HTTP(
            "?do=" + (this.toBeEdit.isnew ? "new" : "edit") + "&type=purchases",
            fd,
            UploadHeader,
            res => {
              //console.log(res);
              if (res.auth) {
                var xx = [];
                this.selectedparts.forEach(e => {
                  if (e.selected != null) {
                    xx.push(e);
                  }
                });
                var ii = this.providers.findIndex(
                  o => o.value == this.toBeEdit.providerid
                );
                if (this.toBeEdit.isnew) {
                  console.log("Insert", {
                    id: res.id,
                    providerid: {
                      text: this.providers[ii].text,
                      value: this.providers[ii].value
                    },
                    total: this.toBeEdit.total,
                    invoice: res,
                    items: xx,
                    paid: this.toBeEdit.paid
                  });
                  this.items.push({
                    id: res.id,
                    providerid: {
                      text: this.providers[ii].text,
                      value: this.providers[ii].value
                    },
                    total: this.toBeEdit.total,
                    invoice: res,
                    items: xx,
                    paid: this.toBeEdit.paid
                  });
                } else {
                  let index = this.items.findIndex(
                    o => o.id == this.toBeEdit.id
                  );
                  if (index != -1) {
                    this.items.splice(index, 1, {
                      id: this.toBeEdit.id,
                      providerid: {
                        text: this.providers[ii].text,
                        value: this.providers[ii].value
                      },
                      total: this.toBeEdit.total,
                      invoice: this.toBeEdit.invoice,
                      items: xx,
                      paid: this.toBeEdit.paid
                    });
                  }
                }
                this.dialog = false;
              } else {
                /// error
              }
            }
          );
        }
      );
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      let c = confirm("Are you sure to remove this record ?");
      if (c) {
        __HAS_PERM(38, this.$store.state.loggedUser.id, () => {
          __HTTP("?do=delete", { type: "purchases", id: item.id }, null, () => {
            this.items.splice(index, 1);
          });
        });
      }
    }
  },
  created() {
    this.getCats();
    this.getProviders();
    //this.getList();
    this.$store.state.title = "Purchases";
  },
  data: () => ({
    valid: true,
    search: "",
    gotcats: false,
    cache: {},
    options: {},
    numberOfPages:0,
    totalItems: 0,
    rows: 0,
    isedit: false,
    cats: [],
    selectedparts: [],
    quan: [],
    unitprice: [],
    providerid: null,
    total: 0,
    isloading: false,
    loadingtext: "Please wait while loading data ...",
    toBeEdit: {
      providerid: "",
      total: "",
      invoice: "",
      paid: "",
      isnew: true,
      shown: true
    },
    headers: [
      {
        sortable: true,
        text: "#",
        value: "id"
      },
      {
        sortable: true,
        text: "Provider",
        value: "providerid.text"
      },
      {
        sortable: true,
        text: "Total amount (USD)",
        value: "total"
      },
      {
        sortable: true,
        text: "Invoice",
        value: "invoice"
      },
      {
        sortable: true,
        text: "Paid in advance ?",
        value: "paid"
      },
      {
        sortable: true,
        text: "Added by",
        value: "addby"
      },
      {
        sortable: true,
        text: "Added on",
        value: "adddate"
      },
      { text: "Tools", value: "action", sortable: false }
    ],
    items: [],
    item: [],
    title: "",
    providers: [],
    dialog: false,
    dialogTitle: "New Purchase Order",
    priceRules: [
      v => !!v || "This field is required",
      v =>
        (v && v.length >= 1) ||
        "Price must be greater equal or greater than 1 digit."
    ]
  })
};
</script>
